/* Quilted Joy — Gift Reggie registry/wishlist page enhancements (2026-09-24).
   Loaded by layout/theme.liquid on /apps/giftregistry* pages only.

   Yardage products sell in ¼-yard units (membership in the yardage-custom
   collection), but Gift Reggie renders plain unit counts. For each registry line
   this script asks the theme's qj-yardage-probe section (Section Rendering API)
   whether the product is yardage and whether its variant is still available, then:

   1) annotates Wants / Has / Needs unit counts with yards ("4 (= 1 yd)");
   2) adds a "per ¼ yd" suffix beside per-unit prices;
   3) shows a quarter-yard explainer banner above the item list;
   4) badges out-of-stock lines and disables their buy controls (the app keeps
      them listed but their Add to Cart would just fail at checkout);
   5) mobile cards: the app's per-line Add to Cart hard-codes quantity 1 (one
      ¼ yd). For yardage lines we take over that click and add the line's still-
      needed units instead, relabelling the button so it says what it adds;
   6) gives quantity inputs (buyer amount boxes and owner "wants" boxes) a live
      "= X yd" hint. */
(function () {
  'use strict';

  var FRACTIONS = ['', '¼', '½', '¾'];

  function yardsLabel(units) {
    units = parseInt(units, 10);
    if (isNaN(units) || units < 0) return '';
    var whole = Math.floor(units / 4);
    var frac = FRACTIONS[units % 4];
    var num = whole > 0 ? whole + frac : frac || '0';
    return num + ' yd';
  }

  function yardsDecimal(units) {
    return (units * 0.25).toFixed(2) + ' Yards';
  }

  /* ---------- probe (Section Rendering API) ---------- */
  var CACHE_KEY = 'qjYardProbe.v1';
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}'); } catch (e) { /* ignore */ }
  var pending = {};

  function probe(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    if (pending[handle]) return pending[handle];
    pending[handle] = fetch('/products/' + encodeURIComponent(handle) + '?section_id=qj-yardage-probe')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-qj-yardage-probe]');
        if (!el) throw new Error('no probe');
        var data = JSON.parse(el.textContent);
        cache[handle] = data;
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) { /* ignore */ }
        return data;
      })
      .catch(function () { return null; });
    return pending[handle];
  }

  /* ---------- row helpers ---------- */
  function handleOf(row) {
    var a = row.querySelector('.giftreggie-item-name[href], p a[href*="/products/"], a[href*="/products/"]');
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function variantOf(row) {
    var i = row.querySelector('input.variant-id, input[name="variant-id"]');
    return i ? i.value : null;
  }

  function note(text, cls) {
    var s = document.createElement('span');
    s.className = cls || 'qj-yd-note';
    s.textContent = text;
    return s;
  }

  /* ---------- annotations ---------- */
  function annotateDesktopRow(row) {
    var needsCell = row.querySelector('td.giftreggie-needs-quantity');
    if (needsCell) {
      var hasCell = needsCell.previousElementSibling;
      var wantsCell = hasCell && hasCell.previousElementSibling;
      [wantsCell, hasCell, needsCell].forEach(function (cell) {
        if (!cell || cell.querySelector('.qj-yd-note')) return;
        var units = parseInt(cell.textContent, 10);
        if (!isNaN(units) && units > 0) cell.appendChild(note(' (= ' + yardsLabel(units) + ')'));
      });
    }
    annotatePrice(row);
    annotateAmountInput(row, '.registry-variant-quantity');
    annotateAmountInput(row, '.giftreggie-want-quantity');
  }

  function annotateMobileRow(row) {
    var table = row.querySelector('table');
    if (table && !row.querySelector('.qj-yd-mobile-note')) {
      var cells = table.querySelectorAll('td');
      if (cells.length >= 3) {
        var wants = parseInt(cells[0].textContent, 10);
        var needs = parseInt(cells[2].textContent, 10);
        var div = document.createElement('div');
        div.className = 'qj-yd-mobile-note';
        div.textContent = 'Wants ' + yardsLabel(wants) +
          (needs !== wants ? ' · still needs ' + yardsLabel(needs) : '') +
          ' (4 units = 1 yard)';
        table.insertAdjacentElement('afterend', div);
      }
    }
    annotatePrice(row);
    annotateAmountInput(row, '.registry-variant-quantity');
    annotateAmountInput(row, '.giftreggie-want-quantity');
  }

  function annotatePrice(row) {
    var priceField = row.querySelector('gr-storefront-field[data-field="variant.price"]');
    if (priceField && !priceField.nextElementSibling?.classList?.contains('qj-yd-price-note')) {
      priceField.insertAdjacentElement('afterend', note(' per ¼ yd', 'qj-yd-note qj-yd-price-note'));
    }
  }

  function annotateAmountInput(row, selector) {
    var input = row.querySelector(selector);
    if (!input || input.dataset.qjYd) return;
    input.dataset.qjYd = '1';
    var hint = note('', 'qj-yd-note qj-yd-input-hint');
    var update = function () {
      var units = parseInt(input.value, 10);
      hint.textContent = !isNaN(units) && units > 0 ? ' = ' + yardsLabel(units) : ' ¼-yd units';
    };
    update();
    input.insertAdjacentElement('afterend', hint);
    input.addEventListener('input', update);
    input.addEventListener('change', update);
  }

  /* ---------- out of stock ---------- */
  function markUnavailable(row) {
    if (row.classList.contains('qj-oos')) return;
    row.classList.add('qj-oos');
    var name = row.querySelector('.giftreggie-item-name');
    if (name && !row.querySelector('.qj-oos-badge')) {
      var b = document.createElement('span');
      b.className = 'qj-oos-badge';
      b.textContent = 'Out of stock right now';
      name.insertAdjacentElement('afterend', b);
    }
    row.querySelectorAll('.giftreggie-add-to-cart').forEach(function (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.textContent = 'Out of Stock';
    });
    row.querySelectorAll('.registry-variant-quantity').forEach(function (inp) {
      inp.disabled = true;
    });
  }

  /* ---------- banner ---------- */
  function ensureBanner() {
    if (document.querySelector('.qj-yd-banner')) return;
    var anchor = document.querySelector('#view-registry, table.giftreggie-view-registry, ul.giftreggie-view-registry');
    if (!anchor) return;
    var div = document.createElement('div');
    div.className = 'qj-yd-banner';
    div.textContent = 'Fabric yardage on this registry is counted in quarter-yard units — 4 units = 1 yard.';
    anchor.parentNode.insertBefore(div, anchor);
  }

  /* ---------- mobile per-line Add to Cart override (yardage rows) ---------- */
  function relabelCartButton(row) {
    var needsEl = row.querySelector('.giftreggie-needs-quantity') || (function () {
      var cells = row.querySelectorAll('table td');
      return cells.length >= 3 ? cells[2] : null;
    })();
    var needs = needsEl ? parseInt(needsEl.textContent, 10) : NaN;
    var units = !isNaN(needs) && needs > 0 ? needs : 1;
    row.querySelectorAll('.giftreggie-add-to-cart:not([disabled])').forEach(function (btn) {
      btn.textContent = 'Add ' + yardsLabel(units) + ' to Cart';
      btn.dataset.qjUnits = units;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.giftreggie-add-to-cart');
    if (!btn || btn.disabled) return;
    var row = btn.closest('.registry-variant');
    if (!row || row.dataset.qjYardage !== '1') return; // non-yardage lines keep app behavior
    e.preventDefault();
    e.stopImmediatePropagation();
    var units = parseInt(btn.dataset.qjUnits, 10) || 1;
    var variantId = variantOf(row);
    if (!variantId) return;
    // Mirror the app's own handler (form POST to /cart/add) so cart tagging and
    // redirect behavior stay identical — but with the real unit count and a
    // Desired Quantity note that matches it.
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    var add = function (n, v) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = n;
      i.value = v;
      form.appendChild(i);
    };
    add('id', variantId);
    add('quantity', units);
    row.querySelectorAll('.property').forEach(function (p) {
      var n = p.querySelector('.property-name');
      var v = p.querySelector('.property-value');
      if (n && v) {
        var key = n.textContent.trim().replace(/:$/, '');
        if (key !== 'Desired Quantity') add('properties[' + key + ']', v.textContent.trim());
      }
    });
    add('properties[Desired Quantity]', yardsDecimal(units));
    document.body.appendChild(form);
    form.submit();
  }, true);

  /* ---------- main ---------- */
  function init() {
    var rows = document.querySelectorAll('tr.registry-variant, li.registry-variant');
    if (!rows.length) return;
    var anyYardage = false;
    rows.forEach(function (row) {
      var handle = handleOf(row);
      if (!handle) return;
      probe(handle).then(function (data) {
        if (!data) return;
        var vid = variantOf(row);
        var variant = vid && data.variants ? data.variants[vid] : null;
        if (variant && variant.available === false) markUnavailable(row);
        if (data.yardage) {
          row.dataset.qjYardage = '1';
          if (!anyYardage) { anyYardage = true; ensureBanner(); }
          if (row.tagName === 'TR') annotateDesktopRow(row);
          else annotateMobileRow(row);
          if (!row.classList.contains('qj-oos')) relabelCartButton(row);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
